import { useState, useEffect } from 'react'
import EmptyRequests from './EmptyRequests'
import RequestPendingItem from './RequestPendingItem'
import RequestReadyItem from './RequestReadyItem'
import { Requests, RequestStatusClaimable, RequestStatusPending } from './types'
import { useWithdrawalData, WithdrawalData } from '../hooks'

interface RequestsListProps {
  selectedRequests: Set<string>
  setSelectedRequests: (updater: (prev: Set<string>) => Set<string>) => void
}

const formatRequests = (data: WithdrawalData) => {
  const requests = [
    ...data.sortedClaimableRequests.map((request) => ({
      token_id: request.stringId,
      status: request,
    })),
    ...data.pendingRequests.map((request) => ({
      token_id: request.stringId,
      status: request,
    })),
  ]

  return requests
}

const RequestsList: React.FC<RequestsListProps> = ({
  selectedRequests,
  setSelectedRequests,
}) => {
  const [requests, setRequests] = useState<Requests>([])
  const { data: withdrawalData } = useWithdrawalData()

  useEffect(() => {
    if (withdrawalData) {
      setRequests(formatRequests(withdrawalData))
    }
  }, [withdrawalData])

  const handleRequestSelect = (tokenId: string, selected: boolean) => {
    setSelectedRequests((prev) => {
      const newSet = new Set(prev)
      if (selected) {
        newSet.add(tokenId)
      } else {
        newSet.delete(tokenId)
      }
      return newSet
    })
  }

  const isEmpty = requests.length === 0

  if (isEmpty) {
    return <EmptyRequests />
  }

  return (
    <div
      style={{
        marginBottom: '20px',
      }}
    >
      {requests.map(({ token_id, status }) => {
        const isClaimable = 'claimableEth' in status

        if (isClaimable) {
          return (
            <RequestReadyItem
              key={`${token_id}-${selectedRequests.has(token_id)}`}
              request={status as RequestStatusClaimable}
              isSelected={selectedRequests.has(token_id)}
              onSelect={(selected) => handleRequestSelect(token_id, selected)}
            />
          )
        } else {
          return (
            <RequestPendingItem
              key={token_id}
              request={status as RequestStatusPending}
            />
          )
        }
      })}
    </div>
  )
}

export default RequestsList
